module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.31001",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.5125",
      "atom": "static-1.5497",
      "client-types": "static-1.505",
      "conversations-error-reporting": "static-1.9246",
      "conversations-internal-pub-sub": "static-1.16415",
      "conversations-internal-schema": "static-1.13551",
      "conversations-message-history": "static-1.13655",
      "conversations-test-sdk": "static-1.10857",
      "conversations-visitor-experience-components": "static-1.24364",
      "data-fetching-client": "static-1.10066",
      "head-dlb": "static-1.5007",
      "hs-promise-utils": "static-1.6009",
      "hs-test-utils": "static-1.8458",
      "hubspot-dlb": "static-2.1911",
      "HubStyleTokens": "static-2.11910",
      "I18n": "static-7.1693",
      "immer": "static-1.104",
      "jasmine-immutable": "static-1.3371",
      "jasmine-runner": "static-1.6869",
      "quartz": "static-1.7591",
      "react-dlb": "static-1.92",
      "react-select-plus": "static-1.117",
      "react-transition-group": "static-2.77",
      "redux-thunk": "static-2.83",
      "reselect": "static-3.15",
      "sanitize": "static-1.4892",
      "StyleGuideUI": "static-3.513",
      "transmute": "static-2.97",
      "urlinator": "static-1.4936",
      "usage-tracker": "static-1.7733",
      "usage-tracker-core": "static-1.7583",
      "usage-tracker-public": "static-1.7544",
      "viral-links-lib": "static-1.7499",
      "visitor-ui-component-library": "static-1.6577",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.5231",
      "conversations-visitor-message-history": "static-1.23101",
      "cssUtils": "static-1.1041",
      "enviro": "static-4.455",
      "flux-actions": "static-1.379",
      "foundations-components": "static-1.8662",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6628",
      "interactive-cards": "static-1.495",
      "hubspot-url-utils": "static-1.4383",
      "immutable": "static-2.88",
      "metrics-js": "static-1.9990",
      "PatternValidationJS": "static-1.3306",
      "PortalIdParser": "static-2.404",
      "pulse": "static-1.1058",
      "raven": "static-3.5925",
      "react": "static-7.202",
      "react-aria": "static-1.76",
      "react-dom": "static-7.85",
      "react-redux": "static-7.80",
      "react-rhumb": "static-1.17152",
      "react-utils": "static-2.5627",
      "redux": "static-4.81",
      "rpc-client-utils": "static-1.5089",
      "redux-toolkit": "static-1.81",
      "sanitize-text": "static-1.8576",
      "signup-constants": "static-1.19846",
      "styled-components": "static-2.100",
      "usage-tracker-multi": "static-1.6147",
      "visitor-ui-component-library-icons": "static-1.6388",
      "hs-promise-rejection-tracking": "static-1.5587",
      "raven-hubspot": "static-1.6232",
      "hoist-non-react-statics": "static-3.9",
      "moment": "static-3.75",
      "quartz-config": "static-1.1369",
      "quartz-core": "static-1.6810",
      "foundations-assets": "static-1.5305",
      "foundations-theming": "static-1.4900",
      "UIComponents": "static-3.8856",
      "conversations-async-data": "static-2.8080",
      "customer-data-email": "static-1.18589",
      "cv-backend-services": "static-1.1607",
      "immutable-less": "static-1.5069",
      "conversations-skeleton-state": "static-1.7602",
      "crm-events-viz-core": "static-1.34332",
      "customer-data-objects": "static-1.8113",
      "icons": "static-2.699",
      "react-input-autosize": "static-2.17",
      "react-performance-metrics-lib": "static-1.971",
      "ui-images": "static-2.1269",
      "apollo-stack-hubspot": "static-3.98",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.92",
      "HeadJS": "static-2.813",
      "framer-motion": "static-1.83",
      "hs-test-utils-bend-plugin": "static-1.3569",
      "msw": "static-1.102",
      "msw-config": "static-1.20",
      "testing-library": "static-1.163",
      "i18n-data": "static-1.233",
      "moment-timezone": "static-5.94",
      "jasmine": "static-4.4728",
      "signup-ui-url-generator": "static-2.8479",
      "quartz-i18n": "static-1.1266",
      "sassPrefix": "static-1.308",
      "bend-plugin-foundations-components": "static-1.4931",
      "floating-ui": "static-1.67",
      "foundations-theming-specialty": "static-1.2616",
      "hs-story-utils": "static-1.9844",
      "react-create-root-preference": "static-1.91",
      "react-virtualized": "static-2.111",
      "tanstack-table": "static-1.65",
      "trellis-assets": "static-1.2953",
      "ui-fonts": "static-1.1172",
      "hs-locale-management": "static-1.365",
      "dompurify": "static-1.11",
      "utility-belt": "static-1.2955",
      "bend-plugin-pulse": "static-1.561",
      "batch-promise": "static-1.1966",
      "chirp-fetch": "static-1.2320",
      "event-emitter": "static-1.1378",
      "fast-json-patch": "static-1.73",
      "hub-http-janus": "static-1.898",
      "quick-fetch": "static-1.4195",
      "csstype": "static-1.50",
      "quartz-head": "static-1.1256",
      "web-vitals": "static-1.18",
      "bend-plugin-chirp-manifest": "static-1.499",
      "quartz-routing": "static-1.1021",
      "usage-tracker-anonymous": "static-1.6150",
      "opentelemetry-fe-types": "static-1.205",
      "dispatcher": "static-1.146",
      "general-store": "static-6.20",
      "hubspotter-http": "static-1.4932",
      "mobile-manifest-mixins": "static-1.596",
      "module-federation": "static-1.37",
      "opentelemetry-fe": "static-1.580",
      "quartz-auth": "static-1.1266",
      "quartz-test": "static-1.1266",
      "quartz-tracking": "static-1.970",
      "trellis-components": "static-1.2972",
      "usage-tracker-container": "static-1.7723",
      "bend-plugin-foundations-theming": "static-1.3383",
      "foundations-theming-base": "static-1.3885",
      "stylex": "static-1.45",
      "HubStyle": "static-2.12217",
      "react-immutable-proptypes": "static-2.8",
      "apollo-dlb": "static-3.98",
      "apollo-link-hub-http": "static-2.5020",
      "customer-data-ui-utilities": "static-1.10252",
      "FileManagerCore": "static-1.40247",
      "FileManagerLib": "static-1.40388",
      "hubspot-apollo-client": "static-1.5295",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.677",
      "timezone-utils": "static-2.5650",
      "ui-gdpr-components": "static-1.10650",
      "ts-schema": "static-1.4364",
      "ai-components-ui-library": "static-1.9928",
      "avatar-components": "static-1.2902",
      "content-assistance-lib": "static-1.8346",
      "crm-component-utils": "static-1.40065",
      "crm-display-components": "static-1.25815",
      "crm-fe-perf": "static-1.23315",
      "crm-links": "static-1.6724",
      "crm-message-bus": "static-1.43998",
      "crm-search-service-types": "static-1.1556",
      "crm-source-interpretation-lib": "static-1.5748",
      "customer-data-communicator": "static-1.46538",
      "customer-data-filters-ui": "static-1.41224",
      "customer-data-objects-ui-components": "static-1.13449",
      "customer-data-properties": "static-1.52889",
      "customer-data-rte": "static-1.33813",
      "draft-plugins": "static-2.22276",
      "file-manager-components": "static-1.24748",
      "trellis-theming": "static-1.1403",
      "framework-data-schema-resolvers": "static-1.7312",
      "frontend-preferences-client": "static-1.8337",
      "hubspot-prosemirror": "static-1.19184",
      "object-comments-thread-lib": "static-1.11533",
      "prosemirror-user-and-team-at-mentions": "static-1.1382",
      "reference-resolvers-lite": "static-1.8526",
      "ui-addon-upgrades": "static-9.18511",
      "universal-associations-select": "static-1.11501",
      "universal-record-utils-lib": "static-1.2245",
      "wootric-nps": "static-1.7266",
      "inbound-db-properties-service-client": "static-1.4112",
      "property-translator": "static-1.5799",
      "segments-query-core": "static-1.1848",
      "bender-build-tools": "static-1.3518",
      "stylex-utils": "static-1.161",
      "opentelemetry-web": "static-1.18",
      "beacon-keepalive-queue": "static-1.119",
      "hub-http-shared-msw-handlers": "static-1.10812",
      "hubspotter-http-shared-msw-handlers": "static-1.10810",
      "usage-tracker-session-replay": "static-1.5419",
      "base-ui": "static-1.26",
      "react-day-picker": "static-1.14",
      "tanstack-virtual": "static-1.42",
      "react-dnd-compat": "static-1.5030",
      "breeze-artifacts-sdk": "static-1.686",
      "copilot-toolkit": "static-1.12049",
      "audio-components": "static-1.6494",
      "ContentUtils": "static-1.69348",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29980",
      "FileManagerImages": "static-1.37899",
      "foundations-components-legacy": "static-1.1687",
      "html-to-image": "static-1.64",
      "immerable": "static-1.4561",
      "react-colorpicker": "static-2.10631",
      "ui-universal-auth": "static-1.9626",
      "video-components": "static-1.14337",
      "video-data-lib": "static-1.35993",
      "video-embed": "static-1.36827",
      "hubspot-apollo-cache": "static-1.754",
      "chatspot-core": "static-1.23520",
      "superstore": "static-1.5178",
      "ui-addon-video-player": "static-1.9057",
      "ui-coaching-tips": "static-1.29511",
      "card-properties-lib": "static-1.45224",
      "commerce-subscription-lib": "static-1.37998",
      "crm-actions": "static-1.6769",
      "crm-cards-sdk": "static-1.44883",
      "customer-data-properties-shared-msw-handlers": "static-1.10139",
      "customer-data-property-utils": "static-1.8465",
      "customer-data-tracking": "static-1.7292",
      "hs-resources": "static-1.616",
      "inbound-db-meta-service-client": "static-1.3744",
      "framework-data-table": "static-2.12751",
      "location-customization-utils-lib": "static-1.10323",
      "restore-request-side-panel-lib": "static-1.1920",
      "calling-error-reporting": "static-1.31748",
      "calling-internal-common": "static-1.31741",
      "calling-usage-tracker": "static-1.6954",
      "crm_data": "static-4.93090",
      "customer-data-content": "static-1.27953",
      "draft-content-plugins": "static-1.29070",
      "draft-convert": "static-2.83",
      "draft-extend": "static-3.87",
      "draft-js": "static-5.89",
      "draft-signature-plugin": "static-1.24801",
      "EmailSignatureEditor": "static-1.25162",
      "hubspot-prosemirror-plugins": "static-1.19176",
      "integration-settings-components": "static-1.16403",
      "integrations-lib": "static-1.17307",
      "integrations-tracking-lib": "static-1.6031",
      "laboratory-lib": "static-3.7570",
      "native-integrations-shared-strings": "static-1.8181",
      "nav-meta": "static-1.30700",
      "onboarding-scopes": "static-1.6871",
      "prosemirror": "static-1.13",
      "prosemirror-copilot": "static-1.12513",
      "quotes-client-types": "static-1.39086",
      "reference-resolvers": "static-1.8597",
      "rich-text-lib": "static-1.20473",
      "sales-email-signature-service-client": "static-1.4269",
      "sequences-lib": "static-1.8687",
      "ui-addon-i18n": "static-1.11565",
      "ui-addon-iframeable": "static-1.9497",
      "ui-business-units-lib": "static-1.9514",
      "ui-shepherd-react": "static-3.10694",
      "user-context": "static-1.5478",
      "whatsapp-sending-lib": "static-1.7061",
      "customer-data-filters-ui-msw-helpers": "static-1.23659",
      "customer-data-reference-ui-components": "static-1.13586",
      "events-data-lib": "static-1.666",
      "FormUrlGenerator": "static-2.5134",
      "framework-builder-read-service-client": "static-1.4292",
      "multi-account-reference-resolvers": "static-1.1423",
      "onboarding-tours": "static-1.17306",
      "reporting-datasets-permissions-lib": "static-1.14674",
      "segments-client-types": "static-1.11982",
      "SharedI18nStrings": "static-1.186",
      "ui-addon-teams": "static-1.21968",
      "calling-global-api": "static-1.66025",
      "calling-lifecycle-internal": "static-1.67407",
      "calling-lifecycle-messages": "static-1.59700",
      "commerce-products-lib": "static-1.10771",
      "conditional-properties-service-client": "static-1.4086",
      "crm-index-visualization-core": "static-1.4682",
      "crm-pipelines-api-client-types": "static-1.4417",
      "external-options-client-types": "static-1.4413",
      "formula-editor": "static-1.14936",
      "google-libphonenumber": "static-1.48",
      "inbounddb-objects-service-types": "static-1.4495",
      "meetings-icalendar-utils-lib": "static-1.1056",
      "multi-currency-client-types": "static-1.3981",
      "object-builder-ui-client": "static-1.49922",
      "pipeline-validation-client-types": "static-1.4253",
      "property-value-citations": "static-1.3503",
      "smart-data-capture-core": "static-1.359",
      "smart-property-lib": "static-1.8528",
      "tiered-pricing": "static-1.2148",
      "topics-actions-lib": "static-1.594",
      "trial-components-library": "static-1.14293",
      "ui-addon-form-validation": "static-1.11339",
      "zustand": "static-1.88",
      "breeze-engine-lib": "static-1.2014",
      "poll-commands": "static-1.3892",
      "video-components-external": "static-1.12335",
      "fdsr-migration-layer": "static-1.431",
      "framework-data-schema-quick-fetch": "static-1.7217",
      "persist-promise": "static-1.4123",
      "content-media-capture": "static-1.5683",
      "emoji-mart": "static-3.6",
      "growth-payments-core": "static-1.26403",
      "knowledge-content-types": "static-1.8703",
      "payment-link-components": "static-1.24345",
      "ui-addon-emoji-picker": "static-1.10286",
      "call-summary": "static-1.40714",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.10958",
      "merchandise-lib": "static-1.283",
      "purchase-motions-components": "static-1.6564",
      "crm-object-search-query-utilities": "static-1.10378",
      "amplitude-session-replay-browser": "static-1.60",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "magpie-lib": "static-1.5854",
      "magpie-types": "static-1.5314",
      "simple-logging-lib": "static-1.3471",
      "cms-field-types": "static-1.5231",
      "content-icons-ui": "static-1.2417",
      "underscore": "static-1.8",
      "nudge-client-utils": "static-1.3324",
      "unified-auth-core-lib": "static-1.1422",
      "social-insights-client-types": "static-1.22840",
      "outpost": "static-1.4553",
      "markdown-it": "static-1.6",
      "growth-onboarding-feedback-components": "static-1.7002",
      "customer-data-sidebar": "static-2.46928",
      "enrichment-lib": "static-1.799",
      "ui-addon-draggable-compat": "static-2.4681",
      "commerce-billing-lib": "static-1.20439",
      "commerce-shared-components-lib": "static-1.19481",
      "commerce-tools-ui-lib": "static-1.11234",
      "customer-data-associations": "static-1.7751",
      "tasks-actions-lib": "static-1.340",
      "reporting-data": "static-1.69191",
      "ui-addon-draggable": "static-3.5165",
      "crm-record-cards-service-types": "static-1.3834",
      "crm_universal": "static-1.22644",
      "SalesContentIndexUI": "static-3.9690",
      "content-embed-lib": "static-1.7757",
      "data-model-builder-lib": "static-1.13399",
      "remote-dom": "static-1.8",
      "remote-ui": "static-1.75",
      "ui-components-test-utils": "static-1.6047",
      "ui-extensions-remote-renderer": "static-1.18110",
      "universal-page-editor-lib": "static-1.3429",
      "integrations-error-boundary-lib": "static-1.14722",
      "redux-observable": "static-1.78",
      "ReduxMessenger": "static-2.10791",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.1140",
      "ai-addon-copilot-preview": "static-1.9140",
      "data-token-picker": "static-1.17046",
      "sequences-client-types-lib": "static-1.8544",
      "foundations-components-test-utils": "static-1.6145",
      "navigation-messaging": "static-1.8390",
      "getting-started-shared-tasks": "static-1.19468",
      "getting-started-shared-tasks-store": "static-1.18586",
      "onboarding-tours-utils": "static-1.1373",
      "messaging-usage-based-billing-components-lib": "static-1.2229",
      "marketing-platform-lib": "static-1.7311",
      "whatsapp-management-lib": "static-1.10220",
      "growth-data-modal": "static-1.6054",
      "growth-onboarding-confetti": "static-1.3483",
      "growth-onboarding-next-action-utils": "static-1.2892",
      "navigation-components": "static-1.19063",
      "onboarding-tours-client": "static-1.5521",
      "ui-shepherd-tracker": "static-1.8075",
      "crm-index-associations-lib": "static-1.6868",
      "shared-worker-versioning": "static-1.11460",
      "voice-sms-access-library": "static-1.2317",
      "commerce-permissions": "static-1.1197",
      "products-iframe-lib": "static-1.8807",
      "products-ui-components-shared-msw-handlers": "static-1.11194",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10895",
      "sales-views-client-types": "static-1.4678",
      "bark-lib": "static-1.16949",
      "browser-prettier": "static-1.11",
      "codemirror": "static-5.105",
      "crm-properties-common-lib": "static-1.6308",
      "react-codemirror": "static-1.11059",
      "data-agent-kit": "static-1.809",
      "fsm": "static-1.4173",
      "policy-lib": "static-1.7226",
      "embedded-academy-lib": "static-1.15854",
      "hubs-service-types": "static-1.1684",
      "purchase-motions-api": "static-1.6567",
      "breeze-engine-chat-components": "static-1.992",
      "breeze-engine-core": "static-1.1292",
      "highlight.js": "static-1.89",
      "content-media-composition-data-lib": "static-1.13487",
      "content-media-compositions": "static-2.17494",
      "idb-keyval": "static-1.54",
      "media-bridge-lib": "static-1.19561",
      "fix-webm-duration": "static-1.33",
      "notification-sounds": "static-1.4844",
      "seat-types-lib": "static-1.947",
      "ui-addon-opt": "static-4.8801",
      "commerce-tours-lib": "static-1.6785",
      "growth-onboarding-reliability": "static-1.5502",
      "sales-checkout-service-client": "static-1.3949",
      "calling-cross-tab-library": "static-1.19723",
      "calling-lifecycle-usage-tracker": "static-1.9575",
      "reactive-lib": "static-1.1142",
      "nudge-custom-function-registry": "static-1.3081",
      "nudge-renderer-utils": "static-1.3400",
      "whisper-core-api": "static-1.7540",
      "card-payment-highlight-lib": "static-1.38209",
      "commerce-contract-lib": "static-1.13659",
      "invoices-highlight-card-lib": "static-1.56065",
      "orders-highlight-card-lib": "static-1.22410",
      "products-highlight-card-lib": "static-1.19054",
      "quotes-highlight-card-lib": "static-1.72996",
      "data-agent-test-utils": "static-1.353",
      "data-agent-utils": "static-1.822",
      "enrichment-settings-lib": "static-1.144",
      "usage-based-billing-components-lib": "static-1.10634",
      "payments-enrollment-embed-lib": "static-1.24102",
      "stripe-embedded-components": "static-1.8159",
      "growth-onboarding-empty-states": "static-1.6450",
      "InboxConnectUtils": "static-4.15753",
      "payments-post-enroll-local-storage-lib": "static-1.5522",
      "qrcode-generator": "static-1.79",
      "reporting-client-types": "static-1.2784",
      "react-flip-move": "static-1.82",
      "FireAlarmUi": "static-1.4806",
      "sales-templates-service-types-lib": "static-1.4456",
      "ui-asset-management-lib": "static-1.11521",
      "association-settings-lib": "static-1.11211",
      "collaboration-sidebar": "static-1.58948",
      "conditional-property-settings-components": "static-1.469",
      "conditional-property-settings-modal": "static-1.13380",
      "data-model-commons-lib": "static-1.13587",
      "ExportDialog": "static-6.10792",
      "final-form": "static-1.82",
      "property-management-iframe": "static-1.14358",
      "property-usages-lib": "static-1.5938",
      "reactflow": "static-1.75",
      "simple-data-table": "static-1.3730",
      "used-in-list-lib": "static-1.7391",
      "visual-association": "static-1.6316",
      "highcharts": "static-8.114",
      "reporting-visualizations": "static-1.61265",
      "ui-extensibility-client-types": "static-1.4336",
      "adobe-sign-auth-lib": "static-1.670",
      "ads-unified-auth-lib": "static-1.1776",
      "custom-vendor-connection-lib": "static-1.190",
      "google-sheets-integration-lib": "static-1.1235",
      "microsoft-drive-auth-lib": "static-1.397",
      "surveymonkey-integration-lib": "static-1.766",
      "slack-ui-library": "static-1.10816",
      "ai-rendering-library": "static-1.11313",
      "ai-settings-ui-library": "static-1.8499",
      "breeze-engine-ui-devtools": "static-1.388",
      "copilot-plugins": "static-1.12021",
      "messaging-shared-utils-lib": "static-1.1678",
      "messaging-user-info-utils-lib": "static-1.1848",
      "content-whatsapp-service-types": "static-1.645",
      "short-messages-app-service-client": "static-1.4344",
      "ui-tool-access": "static-1.10574",
      "onboarding-data-sync-lib": "static-1.2753",
      "growth-onboarding-next-action-components": "static-1.2920",
      "user-context-client": "static-1.4928",
      "nest": "static-1.653",
      "calling-orchestration-schema": "static-1.37094",
      "diff-match-patch": "static-1.7",
      "react-reducer-toolkit": "static-1.16573",
      "browser-eslint": "static-2.57",
      "trellis-story-utils": "static-1.4922",
      "storybook-react": "static-1.43",
      "academy-common-lib": "static-1.15314",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.41289",
      "reporting-enablement": "static-1.24064",
      "settings-ui-lib": "static-1.12949",
      "accounting-integrations-ui-components": "static-1.7716",
      "invoices-ui-lib": "static-1.56081",
      "commerce-products-api": "static-1.2841",
      "invoices-iframe-lib": "static-1.58139",
      "quotes-modal-lib": "static-1.103674",
      "quotes-ui-lib": "static-1.81717",
      "fail-safe": "static-1.372",
      "one-click-checkout": "static-1.656",
      "platform-infra-nav-components": "static-1.7969",
      "reporting-ui-components": "static-2.66460",
      "subscription-experience-data-types": "static-1.15370",
      "marketplace-ui-apps-core": "static-1.19493",
      "stripe-connect-js": "static-1.81",
      "ui-addon-react-router-dom": "static-1.9948",
      "hub-http-contrib": "static-1.3447",
      "ui-addon-sales-email": "static-1.5622",
      "nested-table": "static-1.655",
      "chatspot-widget-iframe": "static-1.23511",
      "collaboration-sidebar-common": "static-1.3745",
      "conditional-property-settings-data": "static-1.487",
      "property-management-common": "static-1.6646",
      "d3": "static-1.7",
      "breeze-onboarding-components": "static-1.962",
      "data-integrations-breeze": "static-1.202",
      "global-styles-ai-lib": "static-1.393",
      "marketplace-embed-ba": "static-1.812",
      "mermaid": "static-1.3",
      "reporting-action-components": "static-1.42270",
      "reporting-snowflake": "static-1.57807",
      "upgrade-components-lib": "static-1.656",
      "ui-brand-identity-lib": "static-1.16802",
      "meetings-connect-utils-lib": "static-1.8035",
      "academy-service-client": "static-1.4112",
      "croppie": "static-2.10",
      "SafeStorage": "static-1.4813",
      "trellis-ecosystem": "static-1.7773",
      "commerce-tax-lib": "static-1.956",
      "price-books-api": "static-1.1932",
      "price-books-components": "static-1.1990",
      "property-description-translator": "static-1.4240",
      "ramp-editor": "static-1.1082",
      "data-quality-ui-library": "static-1.14176",
      "report-customization-components": "static-1.14113",
      "reporting-filters": "static-1.1205",
      "reporting-insights-lib": "static-1.2819",
      "reporting-plugins": "static-1.10908",
      "reporting-reports": "static-1.68867",
      "commerce-analytics-service-client": "static-1.3937",
      "totals-ui-components": "static-1.24479",
      "bend-plugin-fail-safe": "static-1.323",
      "checkout-sdk": "static-3.24594",
      "payment-method-components": "static-1.7265",
      "touchless-buying-components": "static-1.6462",
      "upgrade-catalog-service-types": "static-1.3845",
      "edison-service-client-types": "static-1.813",
      "developer-experience-shared-components": "static-1.10957",
      "marketplace-ui-client-types": "static-1.18368",
      "marketplace-ui-common": "static-1.20961",
      "ui-addon-integrations-directory-panel": "static-2.8388",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.567",
      "onboarding-journeys-lib": "static-1.1146",
      "marketplace-embed": "static-1.23109",
      "marketplace-ui-install": "static-1.947",
      "marketplace-ui-tracking": "static-1.15131",
      "dashboard-lib": "static-1.83176",
      "share-with-third-party-component-lib": "static-1.9130",
      "ContentData": "static-1.69423",
      "line-items-api": "static-1.1251",
      "merge-modal-lib": "static-1.12932",
      "campaign-roi-lib": "static-1.10663",
      "campaigns-utils-lib": "static-1.3652",
      "ui-addon-calendars": "static-2.5782",
      "commerce-totals-service-types": "static-1.4104",
      "hub-http-rxjs": "static-1.867",
      "normalizr": "static-3.9",
      "ramda": "static-1.7",
      "billing-payments-client-types": "static-1.4410",
      "company-details-components": "static-1.6625",
      "emoji-regex": "static-1.7",
      "pricing-pages-ui-components": "static-1.16335",
      "quote-checkout-service-types": "static-1.3877",
      "apps-service-types": "static-1.4067",
      "oauth-service-types": "static-1.4597",
      "ui-product-approvals-common": "static-1.1435",
      "connections-embed-lib": "static-1.1666",
      "ai-studio-lib": "static-1.12652",
      "integrations-reconnect-lib": "static-1.639",
      "ui-product-approvals": "static-1.29540",
      "redux-actions": "static-3.73",
      "advanced-menus-core": "static-1.15734",
      "advanced-menus-lib": "static-1.12512",
      "ui-memberships-settings-lib": "static-1.35085",
      "tinymce-plugins": "static-1.58415",
      "copilot-messaging": "static-1.2299",
      "company-details-service-types": "static-1.4362",
      "pricing-pages-api": "static-1.16200",
      "trellis-ext-dnd": "static-1.459",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15733",
      "simple-menus-lib": "static-1.17250",
      "interframe": "static-3.5160",
      "layout-dnd-components": "static-1.13136",
      "layout-dnd-utils": "static-1.12111",
      "tinymce": "static-5.11",
      "tinymce-data": "static-1.41386",
      "tinymce-themes": "static-1.57271",
      "dnd-kit": "static-1.20",
      "layout-data-lib": "static-1.10436",
      "NamespacedHubStyle": "static-2.9328"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.31001",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.5125",
      "atom": "/atom/static-1.5497",
      "client-types": "/client-types/static-1.505",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.9246",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.16415",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13551",
      "conversations-message-history": "/conversations-message-history/static-1.13655",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10857",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.24364",
      "data-fetching-client": "/data-fetching-client/static-1.10066",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-promise-utils": "/hs-promise-utils/static-1.6009",
      "hs-test-utils": "/hs-test-utils/static-1.8458",
      "hubspot-dlb": "/hubspot-dlb/static-2.1911",
      "HubStyleTokens": "/HubStyleTokens/static-2.11910",
      "I18n": "/I18n/static-7.1693",
      "immer": "/immer/static-1.104",
      "jasmine-immutable": "/jasmine-immutable/static-1.3371",
      "jasmine-runner": "/jasmine-runner/static-1.6869",
      "quartz": "/quartz/static-1.7591",
      "react-dlb": "/react-dlb/static-1.92",
      "react-select-plus": "/react-select-plus/static-1.117",
      "react-transition-group": "/react-transition-group/static-2.77",
      "redux-thunk": "/redux-thunk/static-2.83",
      "reselect": "/reselect/static-3.15",
      "sanitize": "/sanitize/static-1.4892",
      "StyleGuideUI": "/StyleGuideUI/static-3.513",
      "transmute": "/transmute/static-2.97",
      "urlinator": "/urlinator/static-1.4936",
      "usage-tracker": "/usage-tracker/static-1.7733",
      "usage-tracker-core": "/usage-tracker-core/static-1.7583",
      "usage-tracker-public": "/usage-tracker-public/static-1.7544",
      "viral-links-lib": "/viral-links-lib/static-1.7499",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6577",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.5231",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.23101",
      "cssUtils": "/cssUtils/static-1.1041",
      "enviro": "/enviro/static-4.455",
      "flux-actions": "/flux-actions/static-1.379",
      "foundations-components": "/foundations-components/static-1.8662",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6628",
      "interactive-cards": "/interactive-cards/static-1.495",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
      "immutable": "/immutable/static-2.88",
      "metrics-js": "/metrics-js/static-1.9990",
      "PatternValidationJS": "/PatternValidationJS/static-1.3306",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "pulse": "/pulse/static-1.1058",
      "raven": "/raven/static-3.5925",
      "react": "/react/static-7.202",
      "react-aria": "/react-aria/static-1.76",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.80",
      "react-rhumb": "/react-rhumb/static-1.17152",
      "react-utils": "/react-utils/static-2.5627",
      "redux": "/redux/static-4.81",
      "rpc-client-utils": "/rpc-client-utils/static-1.5089",
      "redux-toolkit": "/redux-toolkit/static-1.81",
      "sanitize-text": "/sanitize-text/static-1.8576",
      "signup-constants": "/signup-constants/static-1.19846",
      "styled-components": "/styled-components/static-2.100",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.6147",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6388",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "moment": "/moment/static-3.75",
      "quartz-config": "/quartz-config/static-1.1369",
      "quartz-core": "/quartz-core/static-1.6810",
      "foundations-assets": "/foundations-assets/static-1.5305",
      "foundations-theming": "/foundations-theming/static-1.4900",
      "UIComponents": "/UIComponents/static-3.8856",
      "conversations-async-data": "/conversations-async-data/static-2.8080",
      "customer-data-email": "/customer-data-email/static-1.18589",
      "cv-backend-services": "/cv-backend-services/static-1.1607",
      "immutable-less": "/immutable-less/static-1.5069",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.34332",
      "customer-data-objects": "/customer-data-objects/static-1.8113",
      "icons": "/icons/static-2.699",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.971",
      "ui-images": "/ui-images/static-2.1269",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.98",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.92",
      "HeadJS": "/HeadJS/static-2.813",
      "framer-motion": "/framer-motion/static-1.83",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3569",
      "msw": "/msw/static-1.102",
      "msw-config": "/msw-config/static-1.20",
      "testing-library": "/testing-library/static-1.163",
      "i18n-data": "/i18n-data/static-1.233",
      "moment-timezone": "/moment-timezone/static-5.94",
      "jasmine": "/jasmine/static-4.4728",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8479",
      "quartz-i18n": "/quartz-i18n/static-1.1266",
      "sassPrefix": "/sassPrefix/static-1.308",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4931",
      "floating-ui": "/floating-ui/static-1.67",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2616",
      "hs-story-utils": "/hs-story-utils/static-1.9844",
      "react-create-root-preference": "/react-create-root-preference/static-1.91",
      "react-virtualized": "/react-virtualized/static-2.111",
      "tanstack-table": "/tanstack-table/static-1.65",
      "trellis-assets": "/trellis-assets/static-1.2953",
      "ui-fonts": "/ui-fonts/static-1.1172",
      "hs-locale-management": "/hs-locale-management/static-1.365",
      "dompurify": "/dompurify/static-1.11",
      "utility-belt": "/utility-belt/static-1.2955",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.561",
      "batch-promise": "/batch-promise/static-1.1966",
      "chirp-fetch": "/chirp-fetch/static-1.2320",
      "event-emitter": "/event-emitter/static-1.1378",
      "fast-json-patch": "/fast-json-patch/static-1.73",
      "hub-http-janus": "/hub-http-janus/static-1.898",
      "quick-fetch": "/quick-fetch/static-1.4195",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.1256",
      "web-vitals": "/web-vitals/static-1.18",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.499",
      "quartz-routing": "/quartz-routing/static-1.1021",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6150",
      "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.205",
      "dispatcher": "/dispatcher/static-1.146",
      "general-store": "/general-store/static-6.20",
      "hubspotter-http": "/hubspotter-http/static-1.4932",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.596",
      "module-federation": "/module-federation/static-1.37",
      "opentelemetry-fe": "/opentelemetry-fe/static-1.580",
      "quartz-auth": "/quartz-auth/static-1.1266",
      "quartz-test": "/quartz-test/static-1.1266",
      "quartz-tracking": "/quartz-tracking/static-1.970",
      "trellis-components": "/trellis-components/static-1.2972",
      "usage-tracker-container": "/usage-tracker-container/static-1.7723",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3383",
      "foundations-theming-base": "/foundations-theming-base/static-1.3885",
      "stylex": "/stylex/static-1.45",
      "HubStyle": "/HubStyle/static-2.12217",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "apollo-dlb": "/apollo-dlb/static-3.98",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5020",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10252",
      "FileManagerCore": "/FileManagerCore/static-1.40247",
      "FileManagerLib": "/FileManagerLib/static-1.40388",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5295",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.677",
      "timezone-utils": "/timezone-utils/static-2.5650",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10650",
      "ts-schema": "/ts-schema/static-1.4364",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9928",
      "avatar-components": "/avatar-components/static-1.2902",
      "content-assistance-lib": "/content-assistance-lib/static-1.8346",
      "crm-component-utils": "/crm-component-utils/static-1.40065",
      "crm-display-components": "/crm-display-components/static-1.25815",
      "crm-fe-perf": "/crm-fe-perf/static-1.23315",
      "crm-links": "/crm-links/static-1.6724",
      "crm-message-bus": "/crm-message-bus/static-1.43998",
      "crm-search-service-types": "/crm-search-service-types/static-1.1556",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5748",
      "customer-data-communicator": "/customer-data-communicator/static-1.46538",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41224",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13449",
      "customer-data-properties": "/customer-data-properties/static-1.52889",
      "customer-data-rte": "/customer-data-rte/static-1.33813",
      "draft-plugins": "/draft-plugins/static-2.22276",
      "file-manager-components": "/file-manager-components/static-1.24748",
      "trellis-theming": "/trellis-theming/static-1.1403",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7312",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8337",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19184",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.11533",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.1382",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8526",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18511",
      "universal-associations-select": "/universal-associations-select/static-1.11501",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2245",
      "wootric-nps": "/wootric-nps/static-1.7266",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4112",
      "property-translator": "/property-translator/static-1.5799",
      "segments-query-core": "/segments-query-core/static-1.1848",
      "bender-build-tools": "/bender-build-tools/static-1.3518",
      "stylex-utils": "/stylex-utils/static-1.161",
      "opentelemetry-web": "/opentelemetry-web/static-1.18",
      "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.119",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10812",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10810",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5419",
      "base-ui": "/base-ui/static-1.26",
      "react-day-picker": "/react-day-picker/static-1.14",
      "tanstack-virtual": "/tanstack-virtual/static-1.42",
      "react-dnd-compat": "/react-dnd-compat/static-1.5030",
      "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.686",
      "copilot-toolkit": "/copilot-toolkit/static-1.12049",
      "audio-components": "/audio-components/static-1.6494",
      "ContentUtils": "/ContentUtils/static-1.69348",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29980",
      "FileManagerImages": "/FileManagerImages/static-1.37899",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1687",
      "html-to-image": "/html-to-image/static-1.64",
      "immerable": "/immerable/static-1.4561",
      "react-colorpicker": "/react-colorpicker/static-2.10631",
      "ui-universal-auth": "/ui-universal-auth/static-1.9626",
      "video-components": "/video-components/static-1.14337",
      "video-data-lib": "/video-data-lib/static-1.35993",
      "video-embed": "/video-embed/static-1.36827",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.754",
      "chatspot-core": "/chatspot-core/static-1.23520",
      "superstore": "/superstore/static-1.5178",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29511",
      "card-properties-lib": "/card-properties-lib/static-1.45224",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37998",
      "crm-actions": "/crm-actions/static-1.6769",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.44883",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10139",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8465",
      "customer-data-tracking": "/customer-data-tracking/static-1.7292",
      "hs-resources": "/hs-resources/static-1.616",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3744",
      "framework-data-table": "/framework-data-table/static-2.12751",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10323",
      "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1920",
      "calling-error-reporting": "/calling-error-reporting/static-1.31748",
      "calling-internal-common": "/calling-internal-common/static-1.31741",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6954",
      "crm_data": "/crm_data/static-4.93090",
      "customer-data-content": "/customer-data-content/static-1.27953",
      "draft-content-plugins": "/draft-content-plugins/static-1.29070",
      "draft-convert": "/draft-convert/static-2.83",
      "draft-extend": "/draft-extend/static-3.87",
      "draft-js": "/draft-js/static-5.89",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.24801",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25162",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19176",
      "integration-settings-components": "/integration-settings-components/static-1.16403",
      "integrations-lib": "/integrations-lib/static-1.17307",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6031",
      "laboratory-lib": "/laboratory-lib/static-3.7570",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8181",
      "nav-meta": "/nav-meta/static-1.30700",
      "onboarding-scopes": "/onboarding-scopes/static-1.6871",
      "prosemirror": "/prosemirror/static-1.13",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.12513",
      "quotes-client-types": "/quotes-client-types/static-1.39086",
      "reference-resolvers": "/reference-resolvers/static-1.8597",
      "rich-text-lib": "/rich-text-lib/static-1.20473",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4269",
      "sequences-lib": "/sequences-lib/static-1.8687",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11565",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9497",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9514",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10694",
      "user-context": "/user-context/static-1.5478",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.7061",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23659",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13586",
      "events-data-lib": "/events-data-lib/static-1.666",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.5134",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4292",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1423",
      "onboarding-tours": "/onboarding-tours/static-1.17306",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14674",
      "segments-client-types": "/segments-client-types/static-1.11982",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
      "ui-addon-teams": "/ui-addon-teams/static-1.21968",
      "calling-global-api": "/calling-global-api/static-1.66025",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67407",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59700",
      "commerce-products-lib": "/commerce-products-lib/static-1.10771",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4086",
      "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4682",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4417",
      "external-options-client-types": "/external-options-client-types/static-1.4413",
      "formula-editor": "/formula-editor/static-1.14936",
      "google-libphonenumber": "/google-libphonenumber/static-1.48",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4495",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1056",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3981",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.49922",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4253",
      "property-value-citations": "/property-value-citations/static-1.3503",
      "smart-data-capture-core": "/smart-data-capture-core/static-1.359",
      "smart-property-lib": "/smart-property-lib/static-1.8528",
      "tiered-pricing": "/tiered-pricing/static-1.2148",
      "topics-actions-lib": "/topics-actions-lib/static-1.594",
      "trial-components-library": "/trial-components-library/static-1.14293",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11339",
      "zustand": "/zustand/static-1.88",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.2014",
      "poll-commands": "/poll-commands/static-1.3892",
      "video-components-external": "/video-components-external/static-1.12335",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.431",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7217",
      "persist-promise": "/persist-promise/static-1.4123",
      "content-media-capture": "/content-media-capture/static-1.5683",
      "emoji-mart": "/emoji-mart/static-3.6",
      "growth-payments-core": "/growth-payments-core/static-1.26403",
      "knowledge-content-types": "/knowledge-content-types/static-1.8703",
      "payment-link-components": "/payment-link-components/static-1.24345",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10286",
      "call-summary": "/call-summary/static-1.40714",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10958",
      "merchandise-lib": "/merchandise-lib/static-1.283",
      "purchase-motions-components": "/purchase-motions-components/static-1.6564",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10378",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "magpie-lib": "/magpie-lib/static-1.5854",
      "magpie-types": "/magpie-types/static-1.5314",
      "simple-logging-lib": "/simple-logging-lib/static-1.3471",
      "cms-field-types": "/cms-field-types/static-1.5231",
      "content-icons-ui": "/content-icons-ui/static-1.2417",
      "underscore": "/underscore/static-1.8",
      "nudge-client-utils": "/nudge-client-utils/static-1.3324",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1422",
      "social-insights-client-types": "/social-insights-client-types/static-1.22840",
      "outpost": "/outpost/static-1.4553",
      "markdown-it": "/markdown-it/static-1.6",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7002",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.46928",
      "enrichment-lib": "/enrichment-lib/static-1.799",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4681",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.20439",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19481",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11234",
      "customer-data-associations": "/customer-data-associations/static-1.7751",
      "tasks-actions-lib": "/tasks-actions-lib/static-1.340",
      "reporting-data": "/reporting-data/static-1.69191",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.5165",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3834",
      "crm_universal": "/crm_universal/static-1.22644",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9690",
      "content-embed-lib": "/content-embed-lib/static-1.7757",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.13399",
      "remote-dom": "/remote-dom/static-1.8",
      "remote-ui": "/remote-ui/static-1.75",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.6047",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.18110",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3429",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14722",
      "redux-observable": "/redux-observable/static-1.78",
      "ReduxMessenger": "/ReduxMessenger/static-2.10791",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.1140",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.9140",
      "data-token-picker": "/data-token-picker/static-1.17046",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8544",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6145",
      "navigation-messaging": "/navigation-messaging/static-1.8390",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19468",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18586",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1373",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2229",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.7311",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.10220",
      "growth-data-modal": "/growth-data-modal/static-1.6054",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3483",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2892",
      "navigation-components": "/navigation-components/static-1.19063",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.5521",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8075",
      "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6868",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11460",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.2317",
      "commerce-permissions": "/commerce-permissions/static-1.1197",
      "products-iframe-lib": "/products-iframe-lib/static-1.8807",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11194",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10895",
      "sales-views-client-types": "/sales-views-client-types/static-1.4678",
      "bark-lib": "/bark-lib/static-1.16949",
      "browser-prettier": "/browser-prettier/static-1.11",
      "codemirror": "/codemirror/static-5.105",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6308",
      "react-codemirror": "/react-codemirror/static-1.11059",
      "data-agent-kit": "/data-agent-kit/static-1.809",
      "fsm": "/fsm/static-1.4173",
      "policy-lib": "/policy-lib/static-1.7226",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.15854",
      "hubs-service-types": "/hubs-service-types/static-1.1684",
      "purchase-motions-api": "/purchase-motions-api/static-1.6567",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.992",
      "breeze-engine-core": "/breeze-engine-core/static-1.1292",
      "highlight.js": "/highlight.js/static-1.89",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13487",
      "content-media-compositions": "/content-media-compositions/static-2.17494",
      "idb-keyval": "/idb-keyval/static-1.54",
      "media-bridge-lib": "/media-bridge-lib/static-1.19561",
      "fix-webm-duration": "/fix-webm-duration/static-1.33",
      "notification-sounds": "/notification-sounds/static-1.4844",
      "seat-types-lib": "/seat-types-lib/static-1.947",
      "ui-addon-opt": "/ui-addon-opt/static-4.8801",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6785",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5502",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3949",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19723",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.9575",
      "reactive-lib": "/reactive-lib/static-1.1142",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3081",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3400",
      "whisper-core-api": "/whisper-core-api/static-1.7540",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38209",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.13659",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.56065",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22410",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.19054",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72996",
      "data-agent-test-utils": "/data-agent-test-utils/static-1.353",
      "data-agent-utils": "/data-agent-utils/static-1.822",
      "enrichment-settings-lib": "/enrichment-settings-lib/static-1.144",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10634",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24102",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.8159",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6450",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.15753",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5522",
      "qrcode-generator": "/qrcode-generator/static-1.79",
      "reporting-client-types": "/reporting-client-types/static-1.2784",
      "react-flip-move": "/react-flip-move/static-1.82",
      "FireAlarmUi": "/FireAlarmUi/static-1.4806",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4456",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11521",
      "association-settings-lib": "/association-settings-lib/static-1.11211",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.58948",
      "conditional-property-settings-components": "/conditional-property-settings-components/static-1.469",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.13380",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.13587",
      "ExportDialog": "/ExportDialog/static-6.10792",
      "final-form": "/final-form/static-1.82",
      "property-management-iframe": "/property-management-iframe/static-1.14358",
      "property-usages-lib": "/property-usages-lib/static-1.5938",
      "reactflow": "/reactflow/static-1.75",
      "simple-data-table": "/simple-data-table/static-1.3730",
      "used-in-list-lib": "/used-in-list-lib/static-1.7391",
      "visual-association": "/visual-association/static-1.6316",
      "highcharts": "/highcharts/static-8.114",
      "reporting-visualizations": "/reporting-visualizations/static-1.61265",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4336",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.670",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1776",
      "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.190",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1235",
      "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.397",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.766",
      "slack-ui-library": "/slack-ui-library/static-1.10816",
      "ai-rendering-library": "/ai-rendering-library/static-1.11313",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8499",
      "breeze-engine-ui-devtools": "/breeze-engine-ui-devtools/static-1.388",
      "copilot-plugins": "/copilot-plugins/static-1.12021",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1678",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1848",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.645",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4344",
      "ui-tool-access": "/ui-tool-access/static-1.10574",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2753",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2920",
      "user-context-client": "/user-context-client/static-1.4928",
      "nest": "/nest/static-1.653",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37094",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16573",
      "browser-eslint": "/browser-eslint/static-2.57",
      "trellis-story-utils": "/trellis-story-utils/static-1.4922",
      "storybook-react": "/storybook-react/static-1.43",
      "academy-common-lib": "/academy-common-lib/static-1.15314",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.41289",
      "reporting-enablement": "/reporting-enablement/static-1.24064",
      "settings-ui-lib": "/settings-ui-lib/static-1.12949",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7716",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.56081",
      "commerce-products-api": "/commerce-products-api/static-1.2841",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.58139",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.103674",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.81717",
      "fail-safe": "/fail-safe/static-1.372",
      "one-click-checkout": "/one-click-checkout/static-1.656",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7969",
      "reporting-ui-components": "/reporting-ui-components/static-2.66460",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15370",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19493",
      "stripe-connect-js": "/stripe-connect-js/static-1.81",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9948",
      "hub-http-contrib": "/hub-http-contrib/static-1.3447",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5622",
      "nested-table": "/nested-table/static-1.655",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23511",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3745",
      "conditional-property-settings-data": "/conditional-property-settings-data/static-1.487",
      "property-management-common": "/property-management-common/static-1.6646",
      "d3": "/d3/static-1.7",
      "breeze-onboarding-components": "/breeze-onboarding-components/static-1.962",
      "data-integrations-breeze": "/data-integrations-breeze/static-1.202",
      "global-styles-ai-lib": "/global-styles-ai-lib/static-1.393",
      "marketplace-embed-ba": "/marketplace-embed-ba/static-1.812",
      "mermaid": "/mermaid/static-1.3",
      "reporting-action-components": "/reporting-action-components/static-1.42270",
      "reporting-snowflake": "/reporting-snowflake/static-1.57807",
      "upgrade-components-lib": "/upgrade-components-lib/static-1.656",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16802",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8035",
      "academy-service-client": "/academy-service-client/static-1.4112",
      "croppie": "/croppie/static-2.10",
      "SafeStorage": "/SafeStorage/static-1.4813",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7773",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.956",
      "price-books-api": "/price-books-api/static-1.1932",
      "price-books-components": "/price-books-components/static-1.1990",
      "property-description-translator": "/property-description-translator/static-1.4240",
      "ramp-editor": "/ramp-editor/static-1.1082",
      "data-quality-ui-library": "/data-quality-ui-library/static-1.14176",
      "report-customization-components": "/report-customization-components/static-1.14113",
      "reporting-filters": "/reporting-filters/static-1.1205",
      "reporting-insights-lib": "/reporting-insights-lib/static-1.2819",
      "reporting-plugins": "/reporting-plugins/static-1.10908",
      "reporting-reports": "/reporting-reports/static-1.68867",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3937",
      "totals-ui-components": "/totals-ui-components/static-1.24479",
      "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.323",
      "checkout-sdk": "/checkout-sdk/static-3.24594",
      "payment-method-components": "/payment-method-components/static-1.7265",
      "touchless-buying-components": "/touchless-buying-components/static-1.6462",
      "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3845",
      "edison-service-client-types": "/edison-service-client-types/static-1.813",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10957",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18368",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.20961",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8388",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.567",
      "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1146",
      "marketplace-embed": "/marketplace-embed/static-1.23109",
      "marketplace-ui-install": "/marketplace-ui-install/static-1.947",
      "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15131",
      "dashboard-lib": "/dashboard-lib/static-1.83176",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9130",
      "ContentData": "/ContentData/static-1.69423",
      "line-items-api": "/line-items-api/static-1.1251",
      "merge-modal-lib": "/merge-modal-lib/static-1.12932",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.10663",
      "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3652",
      "ui-addon-calendars": "/ui-addon-calendars/static-2.5782",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4104",
      "hub-http-rxjs": "/hub-http-rxjs/static-1.867",
      "normalizr": "/normalizr/static-3.9",
      "ramda": "/ramda/static-1.7",
      "billing-payments-client-types": "/billing-payments-client-types/static-1.4410",
      "company-details-components": "/company-details-components/static-1.6625",
      "emoji-regex": "/emoji-regex/static-1.7",
      "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16335",
      "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3877",
      "apps-service-types": "/apps-service-types/static-1.4067",
      "oauth-service-types": "/oauth-service-types/static-1.4597",
      "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1435",
      "connections-embed-lib": "/connections-embed-lib/static-1.1666",
      "ai-studio-lib": "/ai-studio-lib/static-1.12652",
      "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.639",
      "ui-product-approvals": "/ui-product-approvals/static-1.29540",
      "redux-actions": "/redux-actions/static-3.73",
      "advanced-menus-core": "/advanced-menus-core/static-1.15734",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12512",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35085",
      "tinymce-plugins": "/tinymce-plugins/static-1.58415",
      "copilot-messaging": "/copilot-messaging/static-1.2299",
      "company-details-service-types": "/company-details-service-types/static-1.4362",
      "pricing-pages-api": "/pricing-pages-api/static-1.16200",
      "trellis-ext-dnd": "/trellis-ext-dnd/static-1.459",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15733",
      "simple-menus-lib": "/simple-menus-lib/static-1.17250",
      "interframe": "/interframe/static-3.5160",
      "layout-dnd-components": "/layout-dnd-components/static-1.13136",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.12111",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-data": "/tinymce-data/static-1.41386",
      "tinymce-themes": "/tinymce-themes/static-1.57271",
      "dnd-kit": "/dnd-kit/static-1.20",
      "layout-data-lib": "/layout-data-lib/static-1.10436",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9328"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.31001",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};